import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import Presentations from '../../components/views/admin/Presentations'
import injectRole from '../../components/HOC/injectRole'

import { TRoles, TRoutes } from '../../shared/const'

/**
 * Präsentationen — nur für die Verwaltung (Landes- und Bundesadmin).
 *
 * Alumni bleiben draußen: Die Präsentationen sind Material der Verwaltung für
 * Partner, kein Teil des lesenden Zugangs.
 */
function PresentationsPage(props) {
	if (![TRoles.ADMIN, TRoles.FEDERAL_ADMIN].includes(props.role)) return <Redirect to={TRoutes.DASHBOARD} />

	return <Presentations />
}

PresentationsPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(PresentationsPage)
